import React from 'react';
import {
	ONBOARDING_REGISTER_ALREADY_ACCOUNT,
	ONBOARDING_REGISTER_LOGIN,
} from '../../../../constants/Copy';
import { ROUTE_LOGIN } from '../../../../constants/Routes';
import { Link } from 'react-router-dom';
import { UserStatusWrapper } from '../../../user-status/UserStatusWrapper';
import AccountNavLink from '../../../common/links/AccountNavLink';
import { UserStatusLoggedIn } from '../../../user-status/UserStatusLoggedIn';

const OnboardingUserStatus = ({ isLoggedIn }) => {
	return (
		<AccountNavLink modifierClass="onboarding-nav-link--no-top-margin">
			<UserStatusWrapper isCentered>
				<UserStatusLoggedIn />
				{!isLoggedIn && (
					<div data-test="tier-options-login-link">
						{ONBOARDING_REGISTER_ALREADY_ACCOUNT}{' '}
						<Link className="onboarding__link accent" tabIndex="0" to={ROUTE_LOGIN}>
							{ONBOARDING_REGISTER_LOGIN}
						</Link>
					</div>
				)}
			</UserStatusWrapper>
		</AccountNavLink>
	);
};

export default OnboardingUserStatus;
